<script>
  import { onMount } from "svelte/internal";
  import CalendarDay from "../components/CalendarDay.svelte";
  import { supabase } from "../auth.js";
  import PopUp from "../components/PopUp.svelte";
  import CreateEventForm from "../components/CreateEventForm.svelte";

  const date = new Date();

  const monthNames = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ];
  const weekdayNames = [
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
    "Sonntag",
  ];

  const monthLengths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  let dayContainer = document.querySelector(".day-view");
  let day;
  let monthName = monthNames[date.getMonth()];
  let year = date.getFullYear();
  let month = date.getMonth();

  let showPopUp = false;

  let monthDays = [];
  let allEvents = [];

  async function fetchEvents() {
    const { body } = await supabase.from("events").select("*");
    allEvents = body;
    dateChanged();
  }

  onMount(() => {
    fetchEvents();
  });

  function previousMonth() {
    date.setMonth(date.getMonth() - 1);
    dateChanged();
  }

  function nextMonth() {
    date.setMonth(date.getMonth() + 1);
    dateChanged();
  }

  function dateChanged() {
    day = date.getDate();
    monthName = monthNames[date.getMonth()];
    year = date.getFullYear();
    month = date.getMonth();

    let weekday = date.getDay();
    let firstOfMonth = new Date();
    firstOfMonth.setDate(1);
    firstOfMonth.setMonth(date.getMonth());
    firstOfMonth.getDay();

    if (dayContainer != null) {
      generatePreDays(firstOfMonth, date.getMonth());
      generateMonthDays();
      generateAfterDays();
    }
  }

  function getActualDay(day) {
    if (day === 0) {
      return 6;
    } else {
      return day - 1;
    }
  }

  function generatePreDays(firstOfMonth, month) {
    monthDays = [];
    let daysBefore =
      monthLengths[month - 1] -
      (monthLengths[month - 1] - getActualDay(firstOfMonth.getDay()));
    for (let i = daysBefore; i > 0; i--) {
      let weekday = monthLengths[month - 1] - i + 1;
      monthDays.push({
        weekday: weekday,
        playday: false,
        events: getEventsPerDay(new Date(year, month, weekday)),
        inactive: true,
        today: isToday(weekday, month - 1, year),
      });
    }
  }

  function generateMonthDays() {
    if (date.getMonth() == 1 && isLeapYear(year)) {
      for (let i = 0; i < 29; i++) {
        monthDays.push({
          weekday: i + 1,
          playday: false,
          events: getEventsPerDay(new Date(year, month - 1, i + 1)),
          inactive: false,
          today: isToday(i + 1, month, year),
        });
      }
    } else {
      for (let i = 0; i < monthLengths[date.getMonth()]; i++) {
        monthDays.push({
          weekday: i + 1,
          playday: false,
          events: getEventsPerDay(new Date(year, month, i + 1)),
          inactive: false,
          today: isToday(i + 1, month, year),
        });
      }
    }
  }

  function isLeapYear(year) {
    let count = 0;
    if (year % 4 == 0) count++;
    if (year % 100 == 0) count--;
    if (year % 400 == 0) count++;
    if (count == 1) {
      return true;
    } else {
      return false;
    }
  }

  function generateAfterDays() {
    let i = 1;
    if (monthDays.length > 35) {
      while (monthDays.length < 42) {
        monthDays.push({
          weekday: i,
          playday: false,
          events: getEventsPerDay(new Date(year, month + 1, i)),
          inactive: true,
          today: isToday(i, month + 1, year),
        });
        i++;
      }
    } else {
      while (monthDays.length < 35) {
        monthDays.push({
          weekday: i,
          playday: false,
          events: getEventsPerDay(new Date(year, month + 1, i)),
          inactive: true,
        });
        i++;
      }
    }
  }

  function isToday(day, month, year) {
    let _date = new Date();

    if (
      _date.getDate() == day &&
      _date.getMonth() == month &&
      _date.getFullYear() == year
    ) {
      return true;
    } else {
      return false;
    }
  }

  function getEventsPerDay(date) {
    let events = [];
    allEvents.forEach((event) => {
      let eventDate = new Date(event.start_date);
      if (
        eventDate.getDate() === date.getDate() &&
        eventDate.getMonth() === date.getMonth() &&
        eventDate.getFullYear() === date.getFullYear()
      ) {
        events.push(event);
      }
    });
    return events;
  }

  let dateToCreateEventFor = new Date();

  function createEvent(event) {
    showPopUp = true;
    dateToCreateEventFor = new Date(year, month, event.detail.weekday);
  }

  let eventToEdit;
  let editEvent = false;

  function updateEvent(event) {
    showPopUp = true;
    editEvent = true;
    eventToEdit = event.detail;
  }

  function closeAll() {
    showPopUp = false;
    editEvent = false;
    eventToEdit = null;
  }
</script>

<PopUp show={showPopUp} on:closed={closeAll}>
  {#if editEvent}
    {#if eventToEdit.user_id === supabase.auth.user().id}
      <CreateEventForm
        date={dateToCreateEventFor}
        on:eventCreated={() => {
          fetchEvents();
          closeAll();
        }}
        editMode={true}
        eventToCreate={eventToEdit}
        id={eventToEdit.id}
      />
    {:else}
      <h1>Not your Event</h1>
    {/if}
  {:else}
    <CreateEventForm
      date={dateToCreateEventFor}
      on:eventCreated={() => {
        fetchEvents();
        closeAll();
      }}
    />
  {/if}
</PopUp>

<div class="calendar">
  <div class="infobar">
    <div class="month-picker">
      <span id="prev-month" class="month-picker-btn" on:click={previousMonth}
        >&lt;</span
      >

      <span class="month">{monthName} {year}</span>

      <span id="next-month" class="month-picker-btn" on:click={nextMonth}
        >&gt;</span
      >
    </div>
    <div class="day-name">
      <p>Montag</p>
      <p>Dienstag</p>
      <p>Mittwoch</p>
      <p>Donnerstag</p>
      <p>Freitag</p>
      <p>Samstag</p>
      <p>Sonntag</p>
    </div>
  </div>
  <div class="day-view" bind:this={dayContainer}>
    {#each monthDays as { weekday, playday, events, inactive, today }, i}
      <CalendarDay
        {weekday}
        {playday}
        {events}
        {inactive}
        {today}
        on:createEvent={createEvent}
        on:editEvent={updateEvent}
      />
    {/each}
  </div>
</div>

<style type="text/scss">
  $bg-color: #f9fafb;

  .calendar {
    $gap: 5px;
    width: 100%;

    // disable text highlighting
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */

    > div {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      grid-auto-rows: 1fr;
      row-gap: $gap;
      column-gap: $gap;
    }

    .infobar {
      grid-template-rows: 50px 40px;
      margin-bottom: 10px;
    }

    .day-view {
      height: 85vh;
    }
  }

  .day-name {
    grid-column: span 7;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: flex-end;
  }

  .month-picker {
    font-size: 1.5em;
    grid-column: span 7;
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    justify-items: center;
    align-items: center;
    width: 330px;
    justify-self: center;

    .month-picker-btn {
      margin-bottom: 3px;
      padding: 0 6px;
      line-height: 97%;
      margin-top: 6px;
      height: 28px;
      border-radius: 5px;

      transition: all 200ms;

      &:hover {
        text-shadow: 0px 0px 5px rgba(255, 255, 255, 0.63);
        background: $bg-color;
        opacity: 0.9;
        cursor: pointer;
      }

      &:first-of-type {
      }
    }

    .month {
      margin: 0 5px;
    }
  }
</style>
